import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { ModalContext } from "../contexts/ModalContext";
import { Context } from "../contexts/AppContext";
import NewGalleryCreateP from "../PropertyList/NewGalleryCreateP";
import { postData } from "../../lib/utils";
import { Link, useNavigate } from "react-router-dom";
import NewGalleryModal from "./NewGalleryModal";
function NewTemplateModal() {

  const navigate = useNavigate();
  const [galleryName, setGalleryName] = useState(null);
 
  const [isGalleryModalOpen, setGalleryModalOpen]=useState(true)//ashwini make it temporary to skip multiple layout screen
 
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const [selectedIndex, setSelectedIndex] = useState(null);

 
 
  Modal.setAppElement("#root");

   useEffect(() => {
     setModalOpen(appState.modalData); // modalOpen को अपडेट करें
   }, [appState.modalData]);
    

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
     
      height: isGalleryModalOpen?"auto":"100%",
      maxWidth:isGalleryModalOpen?"300px":"100%",
      width: "100%",
      overflow: "hidden",
      border:"1px solid #00bcd4",
      borderRadius:"10px",
       
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };

  const openGalleryModal=()=>{
    setAppState((prevState) => ({ ...prevState,
      currentTemplateId:selectedIndex
    }))

  setGalleryModalOpen(true)
   
  }

  const closeModal = () =>  { 
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 
    }

   const goBackHandler=()=>{
    console.log("go back handler")

    closeModal()
   } 

  const btnHandler = async (type) => {
    if (type === "save" && galleryName) {
      
      const json = await postData("galleries/create", {
        name: galleryName,
        title:galleryName, 
        folderId: appState.allFolderData[appState.currentFolderId]._id,
      });
      if (json) {

        console.log("CREATE NEW Gallery JSON  =====",json)
      const data = json;
     
        setAppState((prevState) => ({ ...prevState, 
          currentGalleryName: json.name,
          currentDBGalleryId: data._id
        }));
       
   
    
      closeModal();
        navigate(`/studio/galleries/${json._id}/videos`);
      }
    } else {
      closeModal();
    }
  };

  return (
    <Modal isOpen={modalOpen.isOpen} onRequestClose={closeModal} style={customStyles}>
     {!isGalleryModalOpen &&
     <div>
      {/* Header Section */}
      <div className="flex justify-between">
        <div className="flex gap-4 justify-center items-center">
           
            <button onClick={goBackHandler} className="relative overflow-hidden px-4 py-2 text-white bg-gray-800 rounded-md hover:bg-gray-700 active:scale-95 transition duration-300 ease-in-out shadow-md">
              Go Back
            </button>
          
          <div className="text-lg font-semibold mb-3 md:mb-0">Choose Layout</div>
        </div>
        <div>
          <button
            disabled={selectedIndex === null}
            className={`relative overflow-hidden px-4 py-2 rounded-md transition duration-300 ease-in-out shadow-md ${
              selectedIndex === null
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-gray-800 text-white hover:bg-gray-700 active:scale-95"
            }`}
            onClick={openGalleryModal}
          >
            Create New Album
          </button>
        </div>
      </div>

      {/* Image Grid */}
      <div className="w-full flex justify-between mt-10 gap-4 flex-wrap">
        {[...Array(1)].map((_, index) => (
          <div
            key={index}
            onClick={() => setSelectedIndex(index)}
            className={`w-[30%] min-w-[300px] flex justify-center cursor-pointer transition duration-300 ${
              selectedIndex === index ? "bg-gray-800" : "bg-gray-200"
            } p-2 rounded-lg`}
          >
            <img
              className="w-full max-w-full h-auto rounded-lg shadow-lg"
              src={`../../../img/templates/template${index + 1}.png`}
              alt={`Template ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>}

    {isGalleryModalOpen && <NewGalleryModal/>}
    </Modal>
  );
}

export default NewTemplateModal;


